var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.query.login_type ? _vm.$route.path : _vm.$route.fullPath}),_c('YorkbbsMobileAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }